import { Flex, FlexProps } from '@chakra-ui/react';

const ProductFieldEditInput = (props: FlexProps) => (
  <Flex
    sx={{
      flex: 1,
      flexDir: 'row',
      justifyContent: 'flex-end',
      margin: 0.5,
      alignItems: 'center',
      fontSize: 'sm',
      color: 'base2FontColour.500',
    }}
    {...props}
  />
);

export default ProductFieldEditInput;
